import React from 'react';

import {greyishBlue200} from "assets/jss/main";

function Puller(props) {
    return (
        <div style={{
            position: 'absolute',
            top: 8,
            left: 'calc(50% - 16px)',
            width: 32,
            height: 4,
            backgroundColor: greyishBlue200,
            borderRadius: 48,
        }}></div>
    );
}

export default Puller;
